'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7(outer) {
  this.bUn = null;
  this.bUl = null;
  this.bUm = false;
  this.bUj = null;
  this.bUk = false;
  this.bUo = false;
  this.bUp = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bUn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7 as $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7 };
$p = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$7;
/** @constructor */
function $h_Lpresto_pages_envelopes_EnvelopesView$$anon$7() {
}
export { $h_Lpresto_pages_envelopes_EnvelopesView$$anon$7 as $h_Lpresto_pages_envelopes_EnvelopesView$$anon$7 };
$h_Lpresto_pages_envelopes_EnvelopesView$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bUn;
});
$p.t = (function() {
  if ((!this.bUm)) {
    this.bUl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("up", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bUm = true;
  }
  return this.bUl;
});
$p.ad = (function() {
  if ((!this.bUk)) {
    this.bUj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bUk = true;
  }
  return this.bUj;
});
$p.v = (function() {
  if ((!this.bUp)) {
    this.bUo = false;
    this.bUp = true;
  }
  return this.bUo;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_envelopes_EnvelopesView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_envelopes_EnvelopesView$$anon$7, "presto.pages.envelopes.EnvelopesView$$anon$7", ({
  X0: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_envelopes_EnvelopesView$$anon$7 as $d_Lpresto_pages_envelopes_EnvelopesView$$anon$7 };
//# sourceMappingURL=presto.pages.envelopes.-Envelopes-View$$anon$7.js.map
